  export default[
      {
        path: "/dindvgmryghoiguerygjoidtunfy",
        children: [
          {
            path: "UFWNIUFGTIUVRTERE8TUREYEOIDYMENE",
            name: "qe25.grades",
            component: () => import("@/views/qe/twf/grades/list.vue"),
            meta: {
              title: "QE grade(s)",
              authRequired: true,
              acc: ["y70647"],
            },
          },
          {
            path: "NYHJOFUDIUFYHGREOUUT7YW05UERTUGHTHENTUUT",
            name: "qe25.upload.grades",
            component: () => import("@/views/qe/twf/grades/upload.vue"),
            meta: {
              title: "Upload QE Grade(s)",
              authRequired: true,
              acc: ["y85310"],
            },
          },
        //   {
        //     path: "GVNHERREOWHWI5UT0TEYRHRNUNRYTJ3O5UTUYTER",
        //     name: "bece.update.grades.25",
        //     component: () => import("../views/bece/grades/update.vue"),
        //     meta: {
        //       title: "Update Bece Grade(s)",
        //       authRequired: true,
        //       acc: ["y41288"],
        //     },
        //   },
          {
            path: "JEBHVRWTHERITITYRTWY3T8UNYRTHEBERBORWURWRTTERITH",
            name: "qe25.export.grades",
            component: () => import("@/views/qe/twf/grades/export.vue"),
            meta: {
              title: "Export QE Grade(s)",
              authRequired: true,
              acc: ["y41288"],
            },
          },
        ],
      },
  ]